<app-header
  #header
  [loan]="loan"
  [activeLoan]="activeLoan"
  [notionalLoan]="notionalLoan"
  [currentFXCHLimit]="currentFXCHLimit"
  [maxAllocationAmountPercentage]="maxAllocationAmountPercentage"
  [accounts]="walletBitfinex.accountsConfig.bitfinex"
  [currentUser]="currentUser"
  (pull)="pullAll()"
  (enableAllCurrencyForAllAccountEvent)="enableAllCurrencyForAllAccount()"
  (disableAllCurrencyForAllAccountEvent)="disableAllCurrencyForAllAccount()"
  (handleAccountDisplayEvent)="handleAccountDisplay($event)"
>
</app-header>
<div class="container tabset-container">
  <tabset>
    <tab
      (selectTab)="selectTab(0, EXCHANGES.bitfinex)"
      [customClass]="'customTab'"
      heading="Bitfinex"
      *ngIf="
        currentUser.permissions.includes(PERMISSION_ENUM.BITFINEX_READ) ||
        currentUser.permissions.includes(PERMISSION_ENUM.BITFINEX_WRITE)
      "
    >
      <div
        *ngFor="
          let item of walletBitfinex.positions
            | positionFilter
              : walletBitfinex.accountsConfig
              : header.selectedAccounts
              : EXCHANGES.bitfinex
        "
      >
        <app-position
          class="position bitfinexPosition"
          [item]="item"
          [wallet]="walletBitfinex"
          [exchangeName]="EXCHANGES.bitfinex"
          [pushEnabled]="pushEnabled"
          [showOnlyBitfinexEnabledAccounts]="
            header.showOnlyBitfinexEnabledAccounts
          "
          [target]="target[EXCHANGES.bitfinex]"
          [selectedAccounts]="header.selectedAccounts"
          [isBitfinexTargetEnabled]="isBitfinexTargetEnabled"
          [isSelectorDisabled]="isSelectorDisabled"
          [targetInUSD]="bitfinexTargetInUSD"
          [currentUser]="currentUser"
          (emptyTargetEvent)="emptyTarget($event)"
          (nullTargetEvent)="nullTarget($event)"
          (pullEvent)="pull($event)"
          (pushEvent)="pushData($event)"
          (bitfinexCurrencyEnabledChangeEvent)="
            bitfinexCurrencyEnabledChanged($event)
          "
          (enableAllCurrencyForAccountEvent)="
            enableAllCurrencyForAccount($event)
          "
          (disableAllCurrencyForAccountEvent)="
            disableAllCurrencyForAccount($event)
          "
          (recalculateTargetInUSDEvent)="
            recalculateTargetInUSDByAccountAndCurrency($event)
          "
          (recalculateTargetInGivenCurrencyEvent)="
            recalculateTargetInGivenCurrencyByAccountAndCurrency($event)
          "
        >
        </app-position>
      </div>
    </tab>
    <!--    <tab (selectTab)="selectTab(1, EXCHANGES.bitbay)" [customClass]="'customTab'" heading="Bitbay" *ngIf="currentUser.roles.includes('BITBAY_READ')">-->
    <!--      <div *ngFor="let item of walletBitbay.positions | positionFilter:walletBitbay.accountsConfig:header.selectedAccounts:EXCHANGES.bitbay;">-->
    <!--        <app-position-->
    <!--          class="position bitbayPosition"-->
    <!--          [item]="item"-->
    <!--          [exchangeName]="EXCHANGES.bitbay"-->
    <!--          [wallet]="walletBitbay"-->
    <!--          [pushEnabled]="pushEnabled"-->
    <!--          [target]="target[EXCHANGES.bitbay]"-->
    <!--          [selectedAccounts]="header.selectedAccounts"-->
    <!--          [currentUser]="currentUser"-->
    <!--          (emptyTargetEvent)="emptyTarget($event)"-->
    <!--          (nullTargetEvent)="nullTarget($event)"-->
    <!--          (pullEvent)="pull($event)"-->
    <!--          (pushEvent)="pushData($event)"-->
    <!--          (recalculateTargetEvent)="calculateDifferences(walletBitbay.positions, EXCHANGES.bitbay, $event)"-->
    <!--        ></app-position>-->
    <!--      </div>-->
    <!--    </tab>-->
    <tab
      (selectTab)="selectTab(2, EXCHANGES.bitfinexSwap)"
      [customClass]="'customTab'"
      heading="Bitfinex swap users"
      *ngIf="
        currentUser.permissions.includes(PERMISSION_ENUM.BITFINEX_SWAP_READ) ||
        currentUser.permissions.includes(PERMISSION_ENUM.BITFINEX_SWAP_WRITE)
      "
    >
      <div
        class="row"
        *ngFor="
          let item of walletBitfinexSwap.positions
            | positionFilter
              : walletBitfinexSwap.accountsConfig
              : header.selectedAccounts
              : EXCHANGES.bitfinexSwap
            | orderBy: null : null : false : swapPositionsComparator.bind(this)
        "
      >
        <app-position
          class="position bitfinexPosition"
          [item]="item"
          [wallet]="walletBitfinex"
          [exchangeName]="EXCHANGES.bitfinexSwap"
          [accountsConfig]="walletBitfinex.accountsConfig"
          [pushEnabled]="pushEnabled"
          [showOnlyBitfinexEnabledAccounts]="
            header.showOnlyBitfinexEnabledAccounts
          "
          [target]="target[EXCHANGES.bitfinexSwap]"
          [selectedAccounts]="header.selectedAccounts"
          [isBitfinexTargetEnabled]="isBitfinexSwapTargetEnabled"
          [isSelectorDisabled]="isSelectorDisabled"
          [targetInUSD]="bitfinexTargetInUSD"
          [currentUser]="currentUser"
          (emptyTargetEvent)="emptyTarget($event)"
          (nullTargetEvent)="nullTarget($event)"
          (pullEvent)="
            pullSwapAccounts(
              $event,
              getSwapNumberFromAccountName(item.account.bitfinexAccountName)
            )
          "
          (pushEvent)="pushForBitfinexSwap($event)"
          (bitfinexCurrencyEnabledChangeEvent)="
            bitfinexCurrencyEnabledChanged($event)
          "
          (enableAllCurrencyForAccountEvent)="
            enableAllCurrencyForAccount($event)
          "
          (disableAllCurrencyForAccountEvent)="
            disableAllCurrencyForAccount($event)
          "
          (recalculateTargetInUSDEvent)="
            recalculateTargetInUSDByAccountAndCurrency($event)
          "
          (recalculateTargetInGivenCurrencyEvent)="
            recalculateTargetInGivenCurrencyByAccountAndCurrency($event)
          "
        >
        </app-position>
      </div>
    </tab>
  </tabset>
</div>

<ul *ngIf="errorResponse" id="errorTemplate" style="visibility: hidden">
  <li *ngFor="let item of failedCurrencis">
    {{ '[' + item + ']: ' + errorResponse.message[item] }}
  </li>
</ul>
